const PropTypes = require('prop-types');
// @vendor
const React = require('react');

// @commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const WizardError = require('components/commons/wizardError/wizardError');

// @constants
const PENDING_REPAYMENT_ERROR = "CTO.CON SOLICITUD DE REFINANCIACION PENDIENTE. OPERACION NO PERMITIDA";

const CardPayLaterErrorStep = props => {
    const { immCard, error } = props;
    const goBackButtonLabel = formatText('cardPayLater-backToCard').toUpperCase();
    const goBackButton = {
        label: goBackButtonLabel,
        url: '/myprofile/cards'
    };
    let title;
    let content;

    if (error === PENDING_REPAYMENT_ERROR) {
        title = formatText('cardPayLater-pendingErrorTitle');
        content = (
            <div className="col-xs-6 col-md-7">
                <p>
                    <FormattedText value="cardPayLater-pendingErrorMessagePart1" />
                </p>
                <p>
                    <FormattedText
                        value="cardPayLater-pendingErrorMessagePart2"
                    />
                </p>
            </div>
        );
    } else {
        title = formatText('cardPayLater-errorTitle');
        content = (
            <div className="col-xs-6 col-md-7">
                <p>
                    <FormattedText
                        value="cardPayLater-errorMessage"
                    />
                </p>
            </div>
        );
    }

    return (
        <article className="card-pay-later-error row no-gutter">
            <div className="col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8">
                <WizardError
                    errorMessage={title}
                    mainButton={goBackButton}>
                    <section className="row">
                        <div className="col-xs-6 col-md-5">
                            <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                        </div>
                        {content}
                    </section>
                </WizardError>
            </div>
        </article>
    );
};

CardPayLaterErrorStep.propTypes = {
    immCard: PropTypes.object.isRequired,
    error: PropTypes.string
};

module.exports = CardPayLaterErrorStep;